"use client";
import { useEffect } from "react";

export default function DynamicViewport() {
    useEffect(() => {
        if (navigator.userAgent.includes("Windows")) {
            const metaViewport = document.querySelector("meta[name=viewport]");
            if (metaViewport) {
                metaViewport.setAttribute("content", "width=device-width, initial-scale=0.75");
            }
        }
    }, []);

    return null;
}